import { GlobalConfig } from 'ngx-toastr';

export const TOAST_CONFIG: Partial<GlobalConfig> = {
    maxOpened: 5,
    newestOnTop: false
};
